/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserUpdateContextCto } from '../../models/user-update-context-cto';

export interface GetUser$Json$Params {
  userId: string;
}

export function getUser$Json(http: HttpClient, rootUrl: string, params: GetUser$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UserUpdateContextCto>> {
  const rb = new RequestBuilder(rootUrl, getUser$Json.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserUpdateContextCto>;
    })
  );
}

getUser$Json.PATH = '/user/{userId}';
